import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { AGENCY_INCIDENT_PATH } from '../../../../config/paths';
import IncidentRecordForm from './IncidentRecordForm';
import {
  INCIDENT_RECORD_TYPE,
  INCIDENT_SCOPE_TYPE,
} from '../../../../config/constants';
import {
  clearIncidentsForForm,
  getIncidentsAgencyForm,
} from '../../../../actions/supervision-control';
import { postIncidentRecord } from '../../../../actions/supervision-control/IncidentRecord';
import { tzMergeDateAndTime, tzNormalizeDate } from '../../../../utils/date';

const NewAgencyIncident = ({
  breadcrumbs,
  dispatchPostIncidentRecord,
  dispatchPush,
  dispatchClearIncidentsForForm,
  dispatchGetIncidentsAgencyForm,
}) => {
  useLayoutEffect(() => () => dispatchClearIncidentsForForm(), []);

  const onSubmit = async (formValues) => {
    const {
      incidentId,
      nodePathsPerRow,
      incidentItems,
      dateString,
      timeString,
      agency,
    } = formValues;

    const incidentDate = tzMergeDateAndTime({
      date: dateString,
      time: timeString,
    });

    if (!nodePathsPerRow || Object.keys(nodePathsPerRow).length === 0) {
      toastr.error(
        'Error',
        'Debe seleccionar al menos un nodo para el incidente',
      );
      return;
    }

    const answerList = incidentItems.flatMap((rowValues, rowIndex) => {
      const fieldPrefix = `incidentItems[${rowIndex}]`;
      const nodePath = nodePathsPerRow[`${fieldPrefix}.nodeSelector`] || [];

      return nodePath.map((node, pathIndex) => {
        const note = rowValues[`incidentNodeNote-${pathIndex}`] || null;
        const answer = { nodeId: node.id };
        if (note) answer.note = note;
        return answer;
      });
    });

    const payload = {
      incidentId,
      incidentDate,
      answerList,
      incidentRecordType: INCIDENT_RECORD_TYPE.AGENCY.value,
      agencyId: agency ? agency.value : null,
    };

    await dispatchPostIncidentRecord(payload);
    dispatchPush(AGENCY_INCIDENT_PATH);
  };

  useLayoutEffect(() => {
    dispatchGetIncidentsAgencyForm();
  }, [])

  return (
    <Content
      title="Nuevo Incidente de Agencia"
      subtitle="Registrar un nuevo incidente de agencia"
      breadcrumbs={breadcrumbs}
      content={
        <IncidentRecordForm
          onSubmit={onSubmit}
          initialValues={{
            dateString: tzNormalizeDate(),
            timeString: tzNormalizeDate({ format: 'HH:mm' }),
          }}
          incidentScope={INCIDENT_SCOPE_TYPE.AGENCY.value}
          allowDuplicateNodes={false}
        />
      }
    />
  );
};

NewAgencyIncident.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostIncidentRecord: PropTypes.func.isRequired,
  dispatchPush: PropTypes.func.isRequired,
  dispatchClearIncidentsForForm: PropTypes.func.isRequired,
  dispatchGetIncidentsAgencyForm: PropTypes.func.isRequired,
};

NewAgencyIncident.defaultProps = {};

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  breadcrumbs: [
    ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
    { text: 'Incidentes de Agencia', href: AGENCY_INCIDENT_PATH },
    { text: 'Nuevo', href: '' },
  ],
});

const mapDispatchToProps = {
  dispatchPostIncidentRecord: postIncidentRecord,
  dispatchPush: push,
  dispatchGetIncidentsAgencyForm: getIncidentsAgencyForm,
  dispatchClearIncidentsForForm: clearIncidentsForForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewAgencyIncident);
